module.exports = __webpack_public_path__ + "img/FnrHwdQ6NL60p-HpR7tSl7gYKUE6.e8755cf7.png";